export const VIEW_NOTICE_MODAL = 'VIEW_NOTICE_MODAL';
export const ADD_NOTICE_MODAL = 'ADD_NOTICE_MODAL';

export const setViewNoticeModal = (state) => (dispatch) => {
    dispatch({ type: VIEW_NOTICE_MODAL, state });
};

export const setAddNoticeModal = (state) => (dispatch) => {
    dispatch({ type: ADD_NOTICE_MODAL, state });
};

export default {
    VIEW_NOTICE_MODAL,
    ADD_NOTICE_MODAL,
    setViewNoticeModal,
    setAddNoticeModal,
};
